<template>
  <div class="module-nav">
    <div
      v-if="!responsive"
      class="navbar-icon d-flex align-items-center global-menu"
    >
      <b-nav-item
        v-tooltip="module.label"
        class="d-flex align-items-center"
        :to="to"
      >
        <div>
          <i
            :class="module.icon"
            aria-hidden="true"
          />
        </div>
        <span>{{ module.label }}</span>
      </b-nav-item>
    </div>
    <div
      v-if="responsive"
      class="responsive-view"
    >
      <ul>
        <router-link :to="to">
          <li>
            <div class="d-flex align-items-center">
              <i
                :class="module.icon"
                class="mr-2"
                aria-hidden="true"
              />
              <span>{{ module.label }}</span>
            </div>
          </li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
    name: 'ModuleNav',
    props: {
        module: { type: Object, required: true },
        responsive: { type: Boolean, default: false }
    },
    computed: {
        to() {
            return this.module.routeName && { name: this.module.routeName, params: { resetSideBar: true } }
        }
    }
}

</script>

<style lang="scss">
.module-nav .responsive-view li {
    list-style: none;
    padding: 10px 15px 10px 30px;
    color: vt-color(white-light);
    cursor: pointer;
}
.module-nav .responsive-view li:hover,
.module-nav .responsive-view .router-link-exact-active.router-link-active li {
    background: vt-color(white-light, .9);
}
.navbar .responsive-view .router-link-active::before {
    background: transparent;
}
.module-nav .responsive-view ul {
    margin: 0;
    padding: 0;
}
.module-nav .responsive-view li i {
    font-size: 15px;
    width: 20px;
    text-align: center;
    margin-right: 15px !important;
}
.global-menu .subsections{
  background: #FFF;
  color: #303133;
  left: 55%;
  padding: 5%;
  opacity: 1;
  width: 150px;
}

.global-menu .subsections li{
  padding: 5% 10%;
  font-size: 0.9rem;
  list-style:none;
}

.global-menu .subsections li i{
  text-align: center;
  font-size: 1.1rem;
}

.global-menu .subsections li:hover{
  background: vt-color(light-primary);
  cursor: pointer;
}

.global-menu .registry-active::before {
  content: '';
  width: 30px;
  height: 2px;
  background: white;
  position: absolute;
  bottom: 0;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}

</style>
